/** Matches `useSafeTranslation`’s `t` (not the full i18next `TFunction`). */
export type SimpleTranslateFn = (key: string, fallback?: string) => string;

/**
 * Exact `Message` strings from Quizter.Application.Services.UserService (ArgumentException → 400).
 * Keeps UI aligned with the selected locale instead of showing raw API English.
 */
const USER_SERVICE_BAD_REQUEST: Record<string, string> = {
  'Nickname cannot be empty.': 'user.apiNicknameEmpty',
  'Nickname must be at least 3 characters long.': 'user.apiNicknameTooShort',
  'Nickname must be at most 30 characters long.': 'user.apiNicknameTooLong',
  'Nickname can only contain letters, numbers, underscores (_) and hyphens (-).':
    'user.apiNicknameInvalidChars',
  'This nickname is reserved and cannot be used.': 'user.apiNicknameReserved',
  'Name cannot be empty.': 'user.apiNameEmpty',
  'Name must be at least 2 characters long.': 'user.apiNameTooShort',
  'Name must be at most 50 characters long.': 'user.apiNameTooLong',
  "Name can only contain letters, spaces, hyphens (-) and apostrophes (').": 'user.apiNameInvalidChars',
  'User not found': 'user.apiUserNotFound',
};

const FALLBACK_EN: Record<string, string> = {
  'user.apiNicknameEmpty': 'Nickname cannot be empty.',
  'user.apiNicknameTooShort': 'Nickname must be at least 3 characters long.',
  'user.apiNicknameTooLong': 'Nickname must be at most 30 characters long.',
  'user.apiNicknameInvalidChars':
    'Nickname can only contain letters, numbers, underscores (_) and hyphens (-).',
  'user.apiNicknameReserved': 'This nickname is reserved and cannot be used.',
  'user.apiNameEmpty': 'Name cannot be empty.',
  'user.apiNameTooShort': 'Name must be at least 2 characters long.',
  'user.apiNameTooLong': 'Name must be at most 50 characters long.',
  'user.apiNameInvalidChars':
    "Name can only contain letters, spaces, hyphens (-) and apostrophes (').",
  'user.apiUserNotFound': 'User not found.',
};

/**
 * @returns Translated string if `message` is a known API validation error; otherwise `null`.
 */
export function translateUserApiErrorMessage(
  message: string | undefined,
  t: SimpleTranslateFn
): string | null {
  if (!message?.trim()) return null;
  const key = USER_SERVICE_BAD_REQUEST[message.trim()];
  if (!key) return null;
  return t(key, FALLBACK_EN[key]);
}
